<template>
    <div class="modal-backdrop fade in" v-show="show" v-bind:style="{ zIndex: zIndex }" ></div>
</template>

<script>
export default {
  name: 'HDialog-background',
  data () {
    return {
      show: false
    }
  },
  props: {
    'zIndex': {
      type: Number,
      default: 19861015
    }
  },
  methods: {
    open: function () {
      this.show = true
    },
    close: function () {
      this.show = false
    }
  }
}
</script>

<style lang = "less" scoped>
.modal-backdrop {
  background-color: rgba(0, 0, 0, .5);
}
</style>


// WEBPACK FOOTER //
// ./src/components/ModalBg.vue